export namespace Log {
  type BadgeColour = [string, string, string];

  export const Section = {
    LoadingAsset: 'Loading Asset',
    Transition: 'Transition'
  } as const;
  export type LogSectionKeys = keyof typeof Section;
  export type LogSectionValues = typeof Section[LogSectionKeys];

  export const badgeColours: BadgeColour[] = [
    ['#2192FF', '#fff', '#0000ff'], // Blue
    ['#8D72E1', '#fff', '#6C4AB6'] // Purple
  ];

  export const sectionToColours: Record<LogSectionValues, BadgeColour> = {
    [Section.LoadingAsset]: badgeColours[0],
    [Section.Transition]: badgeColours[1],
  }

  export const badge = (colours: [string, string, string], section: string, message: string) => {
    console.log(
      '%c%s%c%s',
      `background: ${colours[0]}; color: ${colours[1]}; padding: 2px 5px; border-radius: 5px; margin-right: 8px;`,
      section,
      `color: ${colours[2]}; padding: 2px;`,
      message
    );
  };

  export const sectionBadge = (section: LogSectionValues, message: string) => {
    const colours = sectionToColours[section];
    badge(colours, section, message);
  };
}
